export const trainConfigs = {

    APP_ENV: process.env.REACT_APP_ENV,
    API_HOST: "",
    BASE_COOKIE: process.env.REACT_APP_BASE_COOKIE,
    // FUTURE: below needs to remove once api is ready.
    AUTH_BASE_URL: process.env.PUBLIC_URL,
    APP_TITLE_PREFIX: "AI Serving"
};
